
<template>
<div class="captcha flex-container center">
	<div class="captchaMain pos-r">
		<div class="flex-container inputBoxAll">
			<div class="inputBox inputBoxStyle flex1 inputBoxRadius fs-18 text-center center allHeight" :class="(index === showInputText.length && focus && 'activeColor') +' '+(hideText && index < showInputText.length ?'hide':'')" v-for="(index,item) in inputBoxList" >
				<span>{{showInputText[index]}}</span>
				<!-- <i class="input-box-blink blinkColor" v-show="index === showInputText.length && focus"></i>	 -->
			</div>
		</div>
		<div class="hiddenInput allHeight">
			<form class="allHeight" action="" name="form1" id="form1" method="post">
				<input :type="textType === 'number'?'tel':textType" class="fs-18"
					   @keydown="filterInput"
					   @keyup="filterInput"
					   @paste="filterInput"
					   @contextmenu="filterInput"
					   @click="isFocus"
					   :value="inputText" 
					   v-model="inputText"
				>
			</form>
		</div>
	</div>
</div>
</template>

<script>

export default {
	// 在页面中设置css样式
	// .captchaMain 整体的样式 总宽度等
	// .inputBoxAll 整体的输入框样式
	// .inputBoxStyle 输入框的样式，如某个边为透明 背景颜色等
	// .inputBoxRadius 输入框圆角样式 默认有圆角
	// .allHeight 整体高度 包括输入框和背后隐藏的input
	// .activeColor 待输入的输入框的颜色
	// .blinkColor 待输入的闪烁图标的颜色
	// .hiddenInput input的属性
	props: {
		hide:{
			type: Boolean,
			default: false
		},
		textType:{//输入框中文字样式 可选 text number tel
			type: String,
			default:'text'
		},
		maxlength:{//输入文字或数字的个数
			type: Number,
			default:6
		},
		inputText:{ // 输入框中原始内容
			type: String,
			default: ''
		}
	},
	data: function(){
		return {
			focus:false,
			showInputText:''
		}
	}
	, ready: function(){
		this.getRealInputText();
	}
	, methods: {
		isFocus(){
			this.focus = true;
		},
		getRealInputText(){
			let that = this;

			that.inputText = that.inputText.slice(0,that.maxlength);
			if(that.textType === 'number' || that.textType === 'tel'){
				// 数字键盘可以输入+-等符号，type = tel监测并用正则去掉 
				that.inputText = that.inputText.replace(/[^\d]/g,'');
				that.showInputText = that.inputText;
			}else{
				that.showInputText = that.inputText;
			}
			if(that.hide === true){//password
				that.showInputText = that.showInputText.replace(/./g,' ');
			}
		}
	}
	, events: {
		
	}
	,computed:{
		hideText(){
			return this.hide === true;
		},
		inputBoxList(){
			let list = [];
			for(let i = 0, len = this.maxlength;i<len;i++){
				list.push('');
			}
			return list;
		},
		inputBoxHeight(){  
			return this.inputBoxList[0].height;
		}
	}
	, watch:{
		inputText(){
			let that = this;

			that.getRealInputText();			
			
			// 输入完成
			if(this.inputText && this.inputText.length >= this.maxlength){
				this.$dispatch('inputOver',this.inputText);
			}
		}
	}
};
</script>

<style lang="scss">
.captchaMain{
    width: 240px;
}
.inputBox{
	flex-shrink: 0;
	/*border-right-color: transparent;*/
	border-radius: 0;
	position:relative;
}
.inputBoxStyle{
	background-color: #ebebeb;
	line-height: 40px
}
.inputBoxRadius{
	border-radius: 6px;
}
/*.inputBoxRadius:first-child{
	border-radius: 6px 0 0 6px;
}
.inputBoxRadius:last-child{
	border-radius: 0 6px 6px 0;
}*/
.hide:after{
	content: '';
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background-color: #222;
	position: absolute;
	top:calc(50% - 4px);
	left:calc(50% - 4px);
}
/*.inputBox:last-child{
	border-right-color: #ebebeb;
}*/
.activeColor{
	border-color: #16cc90;
}
.blinkColor{
	background-color: #16cc90;
}
.input-box-blink{
	display: block;
	height: 60%;
	width: 2px;
	-webkit-animation: md-codebox-flash steps(2) 1s infinite;
	animation: md-codebox-flash steps(2) 1s infinite;
	position: absolute;
	left: 50%;
	top:20%;
}
@keyframes md-codebox-flash {
	from {
		opacity: 0;
		-ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
		filter: alpha(opacity=0);
	}
	to {
		opacity: 1;
		-ms-filter: none;
		-webkit-filter: none;
		        filter: none;
	}
}
.hiddenInput{
	position: absolute;
	width:100%;
	left: 0;
	top:0;
}
.hiddenInput input{
	width: 100%;
	height: 100%;
	border: 0;
	background: transparent;
	color: transparent;
	padding-left: 8px;
	letter-spacing: 26px;
	text-transform:uppercase;
}
.allHeight{
	height: 40px;
}
</style> 